import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as rxjs from 'rxjs'

import * as gql from './gql'
import type { Context, Methodology } from './types'

/** Maps a supported methodology onto the one the mutation input requires */
const METHODOLOGY = graphql.transformers.IN.nonNull(
  gql.enums.SPACE_RECORD_FUNCTIONAL_METHODOLOGY,
)

/** Space lite record functional usage API */
@ngCore.Injectable()
export class Api {
  /** Functional usage methodology currently recorded for the space record */
  public get(context: Context): rxjs.Observable<Methodology | undefined> {
    return gql.queries.spaceRecordFunctionalUsage.executor(context)
  }

  /** Applies the given methodology to the space record */
  public update({
    context,
    methodology,
  }: Api.Update.Params): rxjs.Observable<Methodology | undefined> {
    return gql.mutations.updateSpaceRecordFunctionalUsage.executor({
      ...context,
      update: {
        functionalizationMethodology: METHODOLOGY.getGqlFrom(methodology),
        // Space Lite has no way to allocate functions, so a methodology that
        // supports them is applied with none allocated.
        ...(ents.extra.space.Record.FunctionalUsage.Methodology.isAssignable(
          methodology,
        ) && { functionalizations: [] }),
      },
    })
  }
}

export namespace Api {
  export namespace Update {
    /** {@link Context}, with the methodology to apply */
    export interface Params {
      readonly context: Context
      readonly methodology: Methodology
    }
  }
}
